import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=76ae87bb&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=76ae87bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae87bb",
  null
  
)

export default component.exports